import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Form } from 'react-bootstrap';
import useProject from '@hooks/useProject';
import { ProjectModel, ProjectModel_DB } from '@models/Models';
import { useForm } from "react-hook-form";
import MyButton from '@components/MyButton';
import { useNavigate } from 'react-router-dom';


const EditProjectTexts = () => {
    const navi = useNavigate();
    const { projectId } = useParams();
    const { getProjectByID, updateProject } = useProject();
    const [projectData, setProjectData] = useState<ProjectModel | null>(null);
    const { register, getValues, setValue } = useForm({
        defaultValues: {
            infoText: projectData?.infoText,
            privacyText: projectData?.datenschutzText,
            firstSMSText: projectData?.sms1Text,
            secondSMSText: projectData?.sms2Text,
        }
    });

    useEffect(() => {
        if(projectData) {
            setValue("infoText", projectData.infoText);
            setValue("privacyText", projectData.datenschutzText);
            setValue("firstSMSText", projectData.sms1Text);
            setValue("secondSMSText", projectData.sms2Text);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectData])

    useEffect(() => {
        if(projectId) {
            projectGetter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId]);

    const projectGetter = async () => {
        const project = await getProjectByID(projectId as string);

        if(!project.success) {
            console.error('Failed to fetch project:', project.message);
            alert(project.message);
            return;
        }

        setProjectData(project.data as ProjectModel);
    };

    const handleSave = async() => {
        const { infoText, privacyText, firstSMSText, secondSMSText } = getValues();

        const updatedProject: Partial<ProjectModel_DB> = {
            infoText: infoText,
            datenschutzText: privacyText,
            sms1Text: firstSMSText,
            sms2Text: secondSMSText
        };

        const updatedProjectResult = await updateProject(projectId as string, updatedProject);

        if(!updatedProjectResult.success) {
            console.error('Failed to update project:', updatedProjectResult.message);
            alert(updatedProjectResult.message);
            return;
        };
        navi(`/pick-mitarbeiter/${projectId}`);
    };

    return (
        <Container className='myCont'>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Control
                            placeholder='Text Information Zurück'
                            as="textarea"
                            rows={30}
                            {...register('infoText')}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Control
                            placeholder='Text Datenschutz'
                            as="textarea"
                            rows={30}
                            {...register('privacyText')}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Row className='mb-4'>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    placeholder='Text 1. SMS Versand'
                                    as="textarea"
                                    rows={14}
                                    {...register('firstSMSText')}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    placeholder='Text 2. SMS Versand'
                                    as="textarea"
                                    rows={14}
                                    {...register('secondSMSText')}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='my-3'>
                <Col className='d-flex align-items-center justify-content-end gap-2'>
                    <MyButton
                        title='Zurück'
                        disabled={false}
                        isSecundary={true}
                        onClick={() => navi("/")}
                    />
                    <MyButton
                        title='Weiter'
                        disabled={false}
                        isSecundary={false}
                        onClick={handleSave}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default EditProjectTexts